import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import { addIndex, ifElse, is, map } from 'ramda';
import { cx } from 'ramda-extension';
import { useDispatch } from 'react-redux';

import Version from 'components/atoms/Version';
import dialog from 'features/common/dialog';

const isArray = is(Array);
const mapIndexed = addIndex(map);

const renderHeaderElement = (header, key) => (
	<div className="Panel-header" key={key}>
		{header}
	</div>
);

export const Panel = ({ children, header, manualHeader, screenId = 0, className }) => {
	const dispatch = useDispatch();

	useEffect(
		() => () => {
			dispatch(dialog.actions.clear());
		},
		[dispatch],
	);

	const renderHeader = () => {
		return ifElse(
			isArray,
			(h) => mapIndexed(renderHeaderElement, h),
			(h) => renderHeaderElement(h),
		)(header);
	};

	const renderChildren = () => {
		if (typeof children === 'string') {
			return <span>{children}</span>;
		}
		return children;
	};

	return (
		<Stack className={cx('Panel', className)}>
			{header && renderHeader()}
			{!!manualHeader && manualHeader}
			<Stack sx={{ paddingY: '40px', paddingX: '40px', color: 'common.black' }}>{renderChildren()}</Stack>
			<Stack className="Panel-footer">
				<Version screenId={screenId} />
			</Stack>
		</Stack>
	);
};

Panel.propTypes = {
	children: PropTypes.any,
	className: PropTypes.string,
	header: PropTypes.node,
	manualHeader: PropTypes.node,
	screenId: PropTypes.number,
};

export default Panel;
